import * as Sentry from '@sentry/vue';
import { getUrlParam, getOSType } from '_lib/utils';
const FILTER_KEYWORDS_LIST = [
  'pageVisibleFromBackend',
  'pageVisibleFromOthersPage',
  'pageHiddenToBackend',
  'pageHiddenToOthersPage',
  'didTakeScreenshot',
];
const FILTER_iOS_NETWORK_ERROR_LIST = ['timeout of 10000ms', 'Network Error'];

const os_type = getOSType();

export default {
  install(Vue) {
    let heybox_id = getUrlParam('heybox_id'),
      app_version = getUrlParam('version');
    let { chunk_id, script_id } = getResourceHash();

    Sentry.init({
      Vue,
      dsn: 'https://551529e8260ad1ade589b4c28559d4d4@monitor.xiaoheihe.cn/2',
      tracesSampleRate: 1,
      sampleRate: 0.6,
      release: SENTRY_RELEASE,
      initialScope: {
        tags: {
          'heybox.id': heybox_id,
          'heybox.version': app_version,
          'network.downlink': navigator.connection
            ? navigator.connection.downlink
            : '-1',
          'network.effectiveType': navigator.connection
            ? navigator.connection.effectiveType
            : 'unkown',
        },
      },
      // debug: true,
      beforeSend: function (event, hint) {
        event.exception.values = filterClientPageHook(event.exception.values);
        if (event.exception.values.length == 0) {
          return;
        }
        event.fingerprint = ['{{ default }}', SENTRY_RELEASE];
        return event;
      },
    });
  },
};

function filterClientPageHook(list) {
  if (os_type === 'iOS') {
    list = list.filter((item) =>
      FILTER_iOS_NETWORK_ERROR_LIST.every((hook) => !item.value.includes(hook)),
    );
  }
  return list.filter((item) =>
    FILTER_KEYWORDS_LIST.every((hook) => !item.value.includes(hook)),
  );
}

function getResourceHash() {
  let res = {};
  for (let dom of document.querySelectorAll('script')) {
    if (dom.src && typeof dom.src == 'string') {
      let match = dom.src.match(/js\/(.*?)\.(\S{8})\.js$/);
      if (match && match[1] && match[2]) {
        if (match[1].includes('chunk')) {
          res['chunk_id'] = match[2];
        } else {
          res['script_id'] = match[2];
        }
      }
    }
  }
  return res;
}
